import { usePathname } from 'next/navigation'
// import Script from 'next/script'

const wwwUrl = 'https://www.17track.net'

function BreadcrumbList({ lang }: { lang: string }) {
  const pathname = usePathname()
  const actualPath = pathname.replace(`/${lang}`, '') || '/'

  // 生成面包屑数据
  const breadcrumbs = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Homepage',
      item: `${wwwUrl}/${lang}`
    }
  ]

  const pathSegments = actualPath.split('/').filter(Boolean)
  let currentPath = ''
  // 处理其他常规路由
  pathSegments.forEach((segment) => {
    // 处理分页情况page-xx
    if (segment.indexOf('page-') !== -1) {
      const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1]
      if (lastBreadcrumb) {
        lastBreadcrumb.item = `${wwwUrl}/${lang}${currentPath}/${segment}`
      }
      return
    }

    const position = breadcrumbs.length + 1
    currentPath += `/${segment}`

    breadcrumbs.push({
      '@type': 'ListItem',
      position,
      name: segment?.charAt(0)?.toUpperCase() + segment?.slice(1).replace(/-/g, ' '),
      item: `${wwwUrl}/${lang}${currentPath}`
    })
  })
  return (
    <>
      {actualPath === '/' ? (
        <>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'WebSite',
                name: '17TRACK',
                url: `${wwwUrl}/${lang}${actualPath}`
              })
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Organization',
                name: '17TRACK',
                url: 'https://www.17track.net/',
                logo: 'https://res.17track.net/global-v2/imgs/logo/svg/square_bot_128x90.svg',
                legalName: '17TRACK, Inc.',
                '@id': 'https://www.17track.net/#organization',
                sameAs: [
                  'https://www.facebook.com/17track',
                  'https://twitter.com/17track',
                  'https://www.linkedin.com/company/17track',
                  'https://www.youtube.com/@17TRACKOFFICIAL'
                ],
                description:
                  '17TRACK supports tracking for 2800+ carriers, including USPS, UPS, FedEx, and DHL. Enter your tracking number to get 99.9% accuracy and real-time updates.',
                subOrganization: [
                  {
                    '@type': 'Organization',
                    name: '17TRACK.COM',
                    url: 'https://www.17track.com/'
                  }
                ],
                contactPoint: {
                  '@type': 'ContactPoint',
                  email: 'intl@17track.net',
                  contactType: 'customer service'
                }
              })
            }}
          />
        </>
      ) : (
        <script
          id="BreadcrumbList"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs
            })
          }}
        />
      )}
    </>
  )
}

export default BreadcrumbList
